import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DBService } from '../../../services/db.service';
import { FAQ } from '../../../model/faq';
import { AuthenticationService } from '../../../services/authentication.service';

declare var $: any;
declare var Materialize: any;

@Component({
  selector: 'app-frequent-questions',
  templateUrl: './frequent-questions.component.html',
  styleUrls: ['./frequent-questions.component.css'],
  providers: [DBService, AuthenticationService]
})
export class FrequentQuestionsComponent implements OnInit {

  panelOpenState = false;
  question: string;
  answer: string;

  faqs: FAQ[];

  loading: boolean;

  isAdminUser: boolean;

  constructor(
    public dialogRef: MatDialogRef<FrequentQuestionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private dbService: DBService, private authService: AuthenticationService) {

      $('#overlay').show();

      this.loadData();

      this.isAdminUser = this.authService.isAdmin();
    }

  hideOverlay(): void {
    $('#overlay').hide();
  }

  ngOnInit() {
  }

  private loadData() {
    this.loading = true;

    this.dbService.listWithUIDs<FAQ>('/faqs')
      .then(faqs => {
        this.faqs = faqs;
        this.loading = false;
      })
      .catch(error => console.log(error));
  }

  register() {
    this.loading = true;
    const faq = new FAQ();
    faq.question = this.question;
    faq.answer = this.answer;

    this.dbService.insertInList<FAQ>('/faqs', faq)
      .then(result => {
        Materialize.toast('faq cadastrada com sucesso', 2000);
        this.question = '';
        this.answer = '';

        this.loadData();
      }).catch(error => console.log(error));
  }

  remove(uid: string) {
    this.loading = true;
    this.dbService.remove('/faqs', uid)
      .then(() => {
        Materialize.toast('FAQ removida com sucesso', 2000)
        this.loadData();
      })
      .catch(error => console.log(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/partials/frequent-questions/frequent-questions.component.ts